import React from 'react';
import { siteContent } from '../content/siteContent';

const Footer = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();
  const { brand, contact, footer } = siteContent;

  return (
    <footer className="relative border-t border-[#D22527]/20 bg-black/50 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src={brand.logoSrc} alt={brand.logoAlt} className="h-10 w-10" />
              <span className="text-2xl font-bold text-white">{brand.name}</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">{brand.tagline}</p>
            <div className="flex flex-wrap gap-3">
              {contact.socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-4 h-10 rounded-lg bg-[#D22527]/10 border border-[#D22527]/30 flex items-center justify-center text-sm text-gray-400 hover:text-white hover:bg-[#D22527]/20 hover:border-[#D22527] transition-all duration-300"
                >
                  {social.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">Solutions</h3>
            <ul className="space-y-3">
              {footer.solutionsLinks.map((label) => (
                <li key={label}>
                  <a href="#solutions" onClick={(e) => scrollToSection(e, '#solutions')} className="text-gray-400 hover:text-[#D22527] transition-colors duration-300">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">Company</h3>
            <ul className="space-y-3">
              {footer.companyLinks.map((item) => (
                <li key={item.label}>
                  <a href={item.href} onClick={(e) => scrollToSection(e, item.href)} className="text-gray-400 hover:text-[#D22527] transition-colors duration-300">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-lg mb-6">Get in Touch</h3>
            <ul className="space-y-3">
              <li>
                <a href={`mailto:${contact.email}`} className="text-gray-400 hover:text-[#D22527] transition-colors duration-300">
                  {contact.email}
                </a>
              </li>
              <li>
                <a href={`tel:${contact.phoneLink}`} className="text-gray-400 hover:text-[#D22527] transition-colors duration-300">
                  {contact.phoneDisplay}
                </a>
              </li>
              <li className="text-gray-400 pt-2">
                {contact.businessHours[0]}
                <br />
                {contact.businessHours[1]}
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#D22527]/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            {footer.copyrightPrefix} {currentYear} {brand.name}. All rights reserved.
          </p>
          <div className="flex gap-6">
            {footer.legalLinks.map((label) => (
              <a key={label} href="#" className="text-gray-400 hover:text-[#D22527] text-sm transition-colors duration-300">
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
